import { render } from "./StockOrderEdit.vue?vue&type=template&id=1a937aac&scoped=true"
import script from "./StockOrderEdit.vue?vue&type=script&lang=js"
export * from "./StockOrderEdit.vue?vue&type=script&lang=js"

import "./StockOrderEdit.vue?vue&type=style&index=0&id=1a937aac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a937aac"]])

export default __exports__